<template>
  <div class="FinalPersonal">
    <my_image :src="title" :width="'50vw'"></my_image>
    <!-- <div class="tip">点击视频观看复赛规则介绍</div> -->
    <!-- <my_video :v="v" :inputStyle="videoStyle"></my_video> -->
    <br>
    <my_image :src="exampleImg" :width="'40vw'"></my_image>
    <div class="important">重要：比赛开始前，请立即进入考场，你的腾讯会议代码是：</div>
    <div class="important red">{{conference_no}}</div>
    <div class="checkRule">
      <div class="title">比赛注意事项</div>
      <div class="list">
        <div>加入考场后，请静音。若无视考场纪律，监考老师将把你移除考场，考试成绩自动取消。</div>
        <div>修改你的名字为<b>真实姓名+省市</b> （如不修改，会被移除考场） </div>
        <div>比赛<b>全程保证你的脸在视频中</b> （考场全程录像），若中途视频出现特殊情况，须向监考老师说明情况。</div>
        <div>有问题可以打开静音问监考老师。监考老师不回答内容相关问题。</div>
        <div>提前交卷，需要在关卡内<b>点击代码区右上角的“提前交卷” 按钮</b>，交卷后无法重新进入比赛。</div>
        <my_image src="/oss/images/0.png" :width="'50vw'"></my_image>
        <div><b>请先点击交卷按钮，再离开腾讯会议，否则系统会<font style="color:red"> 判定作弊</font>。</b></div>
      </div>
      <div class="note" :class="{display: displayRule}">
        我已加入腾讯会议并且阅读同意比赛注意事项，我会遵守比赛规则，保证诚信比赛。 
        <div v-if="this.checkTime()">比赛关卡将于 5 分钟内开放，请稍后</div>
        <div class="btn">
          <my_button :value="'取消'" :inputStyle="smallButton" @click.native="cancel"></my_button>
          <my_button :value="jumpValue()" :inputStyle="smallButton" @click.native="jump" :disable="timeCountDown || checkLimit"></my_button>
        </div>
      </div>
    </div>
    <span title="比赛开始时按钮将自动刷新，无需手动刷新页面"><my_button :value="'同意规则并进入比赛'" :inputStyle="buttonStyle" :disable="disable" @click.native="showRule"></my_button></span>
    <vue_markdown :source="conf" id="conflink" style="width: 60vw;font-size: 0.6em"></vue_markdown>
    <vue_markdown :source="mdfile" id="rule" style="width: 60vw;"></vue_markdown>
    <pdf :src="pdf" v-for="i in numPages" v-if="i!=1" :key="i" :id="i" :page="i"
    >
      <template slot="loading">
        loading content here...
      </template>
    </pdf>
  </div>
</template>

<script>
 // @ is an alias to /src
 import MyImage from '@/components/Image.vue';
 import MyVideo from '@/components/Video.vue';
 import MyButton from '@/components/Button.vue';
 import VueMarkdown from 'vue-markdown'
 import rulemd from 'raw-loader!@/assets/markdown/finalPersonalRule.md';
 import confmd from 'raw-loader!@/assets/markdown/ConfLink.md';
 import pdfvuer from 'pdfvuer'
 import bgImg from '@/assets/image/final/personal-bg.jpg'
 import moment from 'moment'
 export default {
   name: '',
   computed: {
     title () {
       /* return 'https://assets.koudashijie.com/images/magic-rush-bg.jpeg'*/
       return bgImg
     },
     exampleImg(){
       return '/oss/skyspan.png'
     },
     conf() {
       return confmd
     },
     mdfile() {
       return rulemd
     },
     buttonStyle() {
       return {
         'border-radius': '5px',
         'margin-top': '2vw',
         'width': '12em'
       }
     },
     smallButton() {
       return {
         'margin-top': '0.5em',
         'border-radius': '5px',
         'height': '2em',
         'width': '6em'
       }
     },
     myClassroom() {
       return this.$store.state.classrooms[this.$store.state.auth.classroom[0].classroom_id]
       /* return this.$store.state.auth.classroom*/
     },
     checkLimit() {
       // return false to enable button
       return this.finish_at && this.correctTime().isAfter(this.finish_at)
     }
   },
   data () {
     return {
       disable: true,
       interval: null,
       user: null,
       conference_no: '',
       numPages: 0,
       pdf: undefined,
       displayRule: false,
       finish_at: undefined,
       timeCountDown: 3
     }
   },
   methods: {
     checkTime() {
       return this.correctTime().isBefore(this.myClassroom.begin_time)
     },
     jumpValue() {
       if(this.timeCountDown>0)
         return "确定("+this.timeCountDown+")"
       if(this.checkLimit)
         {
           return "您已交卷"
         }
       return "确定"
     },
      getConferece() {
       this.$http.get('/api/classroom').then(
         res => {
           this.conference_no = res.data.conference_no
           this.$store.commit("SET_MY_CLASSROOM", res.data.me_v2)
           this.finish_at = res.data.me_v2[0].finished_at
         }
       )
     },
     jump() {
       this.agree()
       let user = this.user ||  this.$store.state.auth.user
       let redirect = this.myClassroom.entry
       let url = this.$store.state.loginLink + `&redirect=${encodeURIComponent(redirect)}` + `&accessToken=${this.$store.state.auth.token.token}`
       window.open(url)
     },
     correctTime() {
       return moment(+new Date() + this.$store.state.timeDelay)
     },
     getPdf() {
       this.pdf = pdfvuer.createLoadingTask('/oss/pdf/finalpersonal.pdf')
       this.pdf.then(pdf => {
         this.numPages = pdf.numPages
       })
     },
     cancel() {
       this.displayRule = false
     },
     agree() {
       this.displayRule = false
     },
     CountDown() {
       this.timeCountDown -= 1
       if(this.timeCountDown>0){
         setTimeout(this.CountDown, 1000)
       }
     },
     showRule() {
       this.getConferece();
       this.timeCountDown = 3;
       this.CountDown();
       this.displayRule = true
     }
   },
   mounted() {
     this.getConferece()
     this.getPdf()
     let user = this.user ||  this.$store.state.auth.user
     let myClassroom = this.myClassroom
     if(!user || !myClassroom)
       {
         this.$router.push({name: 'frontpage'})
       }
     let that = this
     let startTime = moment(myClassroom.begin_time)
     let timeLimit1 = moment(myClassroom.begin_time).subtract(8, 'minutes');
     let timeLimit2 = moment(myClassroom.begin_time).subtract(5, 'minutes');
     let endTime = moment(myClassroom.end_time)
     let nowTime = this.correctTime()
     console.log(startTime)
     if(nowTime.isBefore(endTime))
       {
         if(nowTime.isAfter(startTime))
           {
             that.disable = false
           }
         else{
           that.interval = setInterval(function() {
             if(that.correctTime().isAfter(timeLimit1))
               {
                 clearInterval(that.interval)
                 that.interval = setInterval(function() {

                   if(that.correctTime().isAfter(timeLimit2))
                     {
                       clearInterval(that.interval)
                       that.disable = false
                     }
                 }, 5000)
               }
           }, 120000)
         }
       }
   },
   components: {
     my_image: MyImage,
     my_video: MyVideo,
     my_button: MyButton,
     vue_markdown: VueMarkdown,
     pdf: pdfvuer
   }
 }
</script>

<style scoped>
 .FinalPersonal{
   margin-top: 6.5625vw;
   display: flex;
   flex-direction: column;
   align-items:center;
   font-size: 1.3vw;
 }
 .tip{
   color: #F17C67;
   font-weight: 500;
   font-size: 26px;
   margin-top: 20px;
 }
 #rule{
   width: 50vw;
 }
 .important, .title{
   font-weight: 600;
   margin: .5em;
 }
 .list {
   margin-left: 2em;
 }
 .list>div{
   position: relative;
 }
 .list>div:before{
   position: absolute;
   left: -1em;
   top: 0;
   content: '-';
 }
 .red{
   color: red;
   font-size: 1.2em;
 }
 .note {
   display: none;
   position: absolute;
   background-color: rgba(240,240, 240);
   box-shadow: 4px 2px 4px 0 #ccc;
   top: 5em;
   align-self: center;
   padding: 10px 20px;
   border-radius: 5px;
   height: 10em;
   flex-direction: column;
   justify-content: center;
   align-items: space-around;
  padding-top: 5vh;
 }
 .checkRule{
   position: relative;
   display: flex;
   flex-direction: column;
 }
 .btn{
   display: flex;
   align-items:center;
   justify-content: space-around;
  margin-top: 2vh;
 }
 
 .display{
   display: flex !important;
 }
</style>